<template>
  <omint-page>
    <Header
      name="Programas de Saúde"
      titleLabel="Programas de Saúde"
    />
    <router-view />
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "ProgramasSaudeIndex",
  components: {
    Header,
    Footer
  },
  mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>
